export default __webpack_public_path__ + "static/media/Edit.16700b34.svg";